
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.252 15.585a5.447 5.447 0 01-5.307-4.213.412.412 0 01.077-.326.389.389 0 01.302-.147h.792a.388.388 0 01.362.25 3.895 3.895 0 006.64 1.556L7.98 11.56a.389.389 0 01.273-.66h3.067a.405.405 0 01.404.388v3.022a.382.382 0 01-.662.272l-.778-.778a5.464 5.464 0 01-4.032 1.781zm6.973-6.24H9.973a2.333 2.333 0 00-.1-1.825l-.74-1.469a3.813 3.813 0 00-.374-.59h2.335a2.325 2.325 0 012.086 1.282l.74 1.479a.779.779 0 01-.695 1.123zm-5.447 0H.775A.778.778 0 01.082 8.22l.74-1.479a2.325 2.325 0 012.084-1.28h2.74a2.33 2.33 0 012.047 1.282l.778 1.479a.778.778 0 01-.693 1.124zm1.938-5.437a1.954 1.954 0 11.008 0h-.008zm-5.44 0A1.945 1.945 0 114.27.018a1.945 1.945 0 01.006 3.889h-.001z"}})])
          )
        }
      }
    